import {LayoutComponent} from "../layout/layout.component";
import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {RincianDataKesehatanComponent} from "./rincian-data-kesehatan.component";

const routes: Routes = [
  {
    path: 'rincian-kesehatan',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: RincianDataKesehatanComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RincianDataKesehatanRoutingModule { }
